// Define custom two-line labels mapping
export const twoLineLabels = {
  "Identity & Access Management": ["Identity & ", "Access Management"],
  "Data Security": ["Data Security"],
  "Network Security": ["Network Security"],
  "Threat Detection& Response": ["Threat Detection", " & Response"],
  "Configuration Management": ["Configuration ", "Management"],
  "Organizational Governance": ["Organizational ", "Governance"],
};

// Custom renderer for two-line Y axis labels
const TwoLineYAxisLabel = ({ y, label, colors }) => {
  const lines = twoLineLabels[label] || [label];

  return (
    <g transform={`translate(0, ${y})`}>
      {lines.map((line, i) => (
        <text
          key={i}
          x={0}
          y={i * 16}
          textAnchor="start"
          dominantBaseline="middle"
          style={{
            fontSize: 12,
            fontWeight: 400,
            color: colors.text_secondary,
            fontFamily: "poppins",
          }}
        >
          {line}
        </text>
      ))}
    </g>
  );
};

export default TwoLineYAxisLabel;
